//@flow
import { isEmpty } from "validator"
import type { Slide } from "./types"

export default ({
  title,
  headline,
  assetId,
  localizedHeadlineText,
  localizedSecondaryText
}: Slide) => {
  const errors = {}
  if (!title || isEmpty(title)) {
    errors.title = "Cannot be blank"
  }
  if (!headline || isEmpty(headline)) {
    errors.headline = "Cannot be blank"
  }
  errors.localizedHeadlineText = {}
  if (
    !localizedHeadlineText ||
    !localizedHeadlineText.en ||
    isEmpty(localizedHeadlineText.en)
  ) {
    errors.localizedHeadlineText.en = "Cannot be blank"
  }
  if (
    !localizedHeadlineText ||
    !localizedHeadlineText.es ||
    isEmpty(localizedHeadlineText.es)
  ) {
    errors.localizedHeadlineText.es = "Cannot be blank"
  }
  errors.localizedSecondaryText = {}
  if (
    !localizedSecondaryText ||
    !localizedSecondaryText.en ||
    isEmpty(localizedSecondaryText.en)
  ) {
    errors.localizedSecondaryText.en = "Cannot be blank"
  }
  if (!assetId || isEmpty(assetId)) {
    errors.assetId = "Cannot be blank"
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/Slides/validate.js